import { useCallback, useContext, useMemo } from "react";
import { HomeContext } from "../../homeContext.ts";

// this is bad but they made me do it
const promoCounts: Record<string, number> = {
  // literature
  "SUB-3585290671": 80,
  // philosophy
  "SUB-2758913916": 23,
  // history
  "SUB-8010164151": 17,
  // court cases
  "SUB-5054596572": 622,
  // Math Science
  "SUB-4294679206": 24,
  // temp
  "SUB-5177574573": 32,
};

export function usePromotions() {
  // this is being used for the "Free Books" swimlane
  // promotions are more varied and were known as shortcuts in fraction
  // but we have been told the data will only be used now for "Free Books" now
  const ctx = useContext(HomeContext);
  const promotions = useMemo(() => {
    if (ctx?.isExploreReady) {
      if (!ctx?.user.promotions) {
        return [];
      } else {
        return ctx?.user.promotions
          .filter((p) => p.type === "FREE_SUBSCRIPTION")
          .map((p) => ({ ...p, count: promoCounts[p.value] ?? 0 }));
      }
    }
  }, [ctx?.isExploreReady, ctx?.user.promotions]);

  const getPromotion = useCallback(
    (vbid: string) => {
      if (promotions) {
        return promotions.find((p) => p.value === vbid);
      }
      return null;
    },
    [promotions]
  );

  return {
    promotions,
    getPromotion,
  };
}
